import axios from 'axios';
import qs from 'qs';
import { Message, MessageBox } from 'element-ui';
import { getToken } from '@/utils/auth';
import store from '@/store';
import { POBrowser } from 'js-pageoffice';

axios.defaults.timeout = 600000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API; //这里可以设置跨域的地址名称，查看vue.config.js文件，跨域那块设置的名称是'/api'，所有这里就要写'/api'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

axios.interceptors.request.use(
  config => {
    const token = getToken();

    if (token) {
      //必须。设置后端代理,具体属性值以您实际开发为准,比如POBrowser.setProxyBaseAPI(process.env.VUE_APP_BASE_API);
      POBrowser.setProxyBaseAPI('/api');
      //必须。向PageOffice后端请求设置header，支持多次调用setHeader()设置更多的值，具体属性名称和属性值以您实际开发为准。
      POBrowser.setHeader('Authorization', 'Bearer ' + token);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    if (response.data.status == 201) {
      MessageBox.alert('token已过期，请重新登录。', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        callback: async () => {
          await store.dispatch('user/logout');
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        }
      });
    }

    if ((response.data.status && response.data.status != 0) || response.data.success === false) {
      Message.error(response.data.message ? response.data.message : '网络异常,请刷新重试！');
      return Promise.reject(response.data.message ? response.data.message : '无错误信息返回');
    }
    return response;
  },
  error => {
    Message({
      message: error.message || '网络异常,请刷新重试！',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default axios;

/**
 * POST封装
 * @param url
 * @param params
 */
export function post(url, params = {}, headers = null) {
  let token = { token: getToken() };
  const reqParams = { ...token, ...params };
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(reqParams), headers)
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function postJson(url, params = {}) {
  let token = { token: getToken() };
  const reqParams = { ...token, ...params };
  return new Promise((resolve, reject) => {
    axios
      .post(url, reqParams, { headers: { 'Content-Type': 'application/json;charset=UTF-8' } })
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 上传文件
 * @param url
 * @param params
 */
export function filePost(url, file) {
  let token = { token: getToken() };
  Object.assign(file, token);
  return new Promise((resolve, reject) => {
    axios
      .post(url, file, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 下载文件
 * @param url
 * @param params
 */
export function postFileDownload(url, params = {}, headers = null) {
  let token = { token: getToken() };
  const reqParams = { ...token, ...params };
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(reqParams), headers)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * GET封装
 * @param url
 * @returns {Promise<any>}
 */
export function get(url, params = {}) {
  let token = { token: getToken() };
  const reqParams = { ...token, ...params };
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: reqParams })
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}
